<template>
    <section>
        <row>
            <column lg="2" md="3">
                <div>
                    <div class="text-nowrap">
                        {{
                            trans('stakeholders.overview.assets_count.label', {
                                count: maintainer.assetsCount || 0,
                            })
                        }}
                    </div>
                    <div class="text-nowrap">
                        {{
                            trans(
                                'stakeholders.overview.locations_count.label',
                                {
                                    count:
                                        maintainer.topLevelLocationsCount || 0,
                                },
                            )
                        }}
                    </div>
                    <hr class="d-md-none" />
                </div>
            </column>
            <column lg="4" md="5">
                <div v-if="isTablet">
                    <popover
                        v-if="
                            maintainer.workingHours?.length &&
                            maintainer.workingHours !== '24/7'
                        "
                        @click.stop=""
                    >
                        <template #toggler="{ id, on }">
                            <div
                                :aria-describedby="id"
                                class="d-inline-flex align-items-center text-primary clickable gap-1"
                                tabindex="0"
                                v-on="on"
                            >
                                <icon name="cil-clock" />
                                {{
                                    trans('maintainers.sla.working_hours.title')
                                }}
                            </div>
                        </template>
                        <working-hours
                            :working-hours="maintainer.workingHours"
                        />
                    </popover>
                    <div v-else>
                        <div class="d-flex align-items-center gap-1">
                            <icon name="cil-clock" />
                            24/7
                        </div>
                    </div>
                </div>
                <div>
                    <div v-if="maintainer.email">
                        <email-link
                            :email="maintainer.email"
                            :show-icon="true"
                            @click.stop=""
                        />
                    </div>
                    <div v-if="maintainer.phone">
                        <phone-link :number="maintainer.phone" @click.stop="" />
                    </div>
                    <div
                        v-if="maintainer.description"
                        class="d-flex align-items-top gap-1"
                    >
                        <icon
                            name="cil-briefcase"
                            style="position: relative; top: 1px"
                        />
                        <span>{{ maintainer.description }}</span>
                    </div>
                </div>
            </column>
            <column v-if="!isTablet" lg="5" md="4">
                <working-hours :working-hours="maintainer.workingHours" />
            </column>
        </row>
    </section>
</template>
<script setup>
import EmailLink from '@/Components/EmailLink.vue';
import PhoneLink from '@/Components/PhoneLink.vue';
import WorkingHours from '@/Pages/Stakeholders/Maintainers/WorkingHours.vue';
import { isTablet } from '@/Utils/UseMedia';
import Popover from '@/Components/Popover.vue';
import Column from '@/Components/Column.vue';

defineProps({ maintainer: Object });
</script>
